

/**
 * Checks if the given participant is a favorite.
 *
 * @param {object} participant - The participant object to check.
 * @return {boolean} Returns true if the participant is a favorite, false otherwise.
 */
export function isParticipantFavorite(participant) {
    return participant && participant.is_favorite;
}